module.exports = __webpack_public_path__ + "134aefa5125f69a17d6b7e3dfca38174.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_2_0.woff2
// module id = 2252
// module chunks = 2